const labels: Record<string, string> = {
  en: "Change language",
  id: "Ganti bahasa",
  ar: "تغيير اللغة",
  de: "Sprache ändern",
  es: "Cambiar idioma",
  fr: "Changer de langue",
  it: "Cambia lingua",
  ja: "言語を変更",
  ko: "언어 변경",
  ms: "Tukar bahasa",
  my: "ဘာသာစကား ပြောင်းရန်",
  ru: "Изменить язык",
  th: "เปลี่ยนภาษา",
  vi: "Đổi ngôn ngữ",
  zh: "切换语言",
  "zh-tw": "切換語言",
};

/** Accessible fallback when the merchant has no Change_language label. */
export function languageControlLabel(locale = "en"): string {
  const code = locale.toLowerCase();
  return labels[code] || labels[code.split("-")[0]] || labels.en;
}
